import React, { useEffect, useState } from "react";

export function timeLeftLabel(until) {
  const ms = new Date(until).getTime() - Date.now();
  if (ms <= 0) return "lifting…";
  const totalMin = Math.floor(ms / 60000);
  const d = Math.floor(totalMin / 1440);
  const h = Math.floor((totalMin % 1440) / 60);
  const m = totalMin % 60;
  if (d > 0) return `${d}d ${h}h left`;
  if (h > 0) return `${h}h ${m}m left`;
  if (m > 0) return `${m}m left`;
  return "<1m left";
}

// Live countdown that re-renders every 30s.
export function TimeLeft({ until }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 30000);
    return () => clearInterval(id);
  }, []);
  return <>{timeLeftLabel(until)}</>;
}
